/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSelectedContentProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import QuestionFormat from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionformat/questionformat';



/* ========== ~~~~~~~~~~ EMBED QUESTION FORMAT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { type }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        selectedType: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent].questionBased.type: null,
        type
    }
};

const mapDispatchToProps = dispatch => ({
    setSelectedContentProperty: (isSharedProperty, property, value) => dispatch(setSelectedContentProperty(isSharedProperty, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionFormat);
